import React from "react";

export function IndicadoresFator(props) {
    const padding = `${props.paddingBlock != null ? props.paddingBlock : 5}px 4px`;

    if (props.modoTabela) {
        return (
            <>
                <table border="1" width={'100%'} height={props.heightTabela} style={{borderColor:props.borderColorTabela}}> 
                    <tbody>
                        <tr>
                            <td>
                                <div>
                                    <div style={{ minWidth: 85 }}>Sazonalidade</div>
                                    <div> {props.sazonalidadeDiferenteDaUC ? "-" : parseFloat(props.item.sazonalidade).toFixed(2).replace(".", ",")}</div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>
                                    <div style={{ minWidth: 85 }}>Fator de Carga</div>
                                    <div>
                                        {props.item.id_modalidade_tarifaria == 1 ? (
                                            <div> {isNaN(parseFloat(props.item.fator_carga)) ? " - " : parseFloat(props.item.fator_carga).toFixed(2).replace(".", ",")}</div>
                                        ) : props.item.id_modalidade_tarifaria == 2 ? (
                                            <div>
                                                <span>
                                                    {"FP: "}{" "}
                                                    {isNaN(parseFloat(props.item.fator_carga_fora_ponta))
                                                        ? " - "
                                                        : parseFloat(props.item.fator_carga_fora_ponta).toFixed(2).replace(".", ",")}
                                                </span>
                                                <span>
                                                    {"  |  P: "}{" "}
                                                    {isNaN(parseFloat(props.item.fator_carga_ponta))
                                                        ? " - "
                                                        : parseFloat(props.item.fator_carga_ponta).toFixed(2).replace(".", ",")}
                                                </span>
                                            </div>
                                        ) : (
                                            " - "
                                        )}
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div>
                                    <div style={{ minWidth: 85 }}>Fator de Demanda</div>
                                    <div>
                                        {props.item.id_modalidade_tarifaria == 1 ? (
                                            <div>
                                                {isNaN(parseFloat(props.item.fator_demanda_fora_ponta))
                                                    ? " - "
                                                    : parseFloat(props.item.fator_demanda_fora_ponta).toFixed(2).replace(".", ",")}
                                            </div>
                                        ) : props.item.id_modalidade_tarifaria == 2 ? (
                                            <div>
                                                <span>
                                                    {"FP: "}{" "}
                                                    {isNaN(parseFloat(props.item.fator_demanda_fora_ponta))
                                                        ? " - "
                                                        : parseFloat(props.item.fator_demanda_fora_ponta).toFixed(2).replace(".", ",")}
                                                </span>
                                                <span>
                                                    {"  |  P: "}{" "}
                                                    {isNaN(parseFloat(props.item.fator_demanda_ponta))
                                                        ? " - "
                                                        : parseFloat(props.item.fator_demanda_ponta).toFixed(2).replace(".", ",")}
                                                </span>
                                            </div>
                                        ) : (
                                            " - "
                                        )}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </>
        );
    }

    return (
        <>
            <div style={{ backgroundColor: "#00a5c2", padding, borderRadius: 3, marginBottom: 1 }}>
                <div style={{ minWidth: 85 }}>Sazonalidade</div>
                <div> {props.sazonalidadeDiferenteDaUC ? "-" : parseFloat(props.item.sazonalidade).toFixed(2).replace(".", ",")}</div>
            </div>
            <div style={{ backgroundColor: "#317ffe", padding, borderRadius: 3, marginBottom: 1 }}>
                <div style={{ minWidth: 85 }}>Fator de Carga</div>
                <div>
                    {props.item.id_modalidade_tarifaria == 1 ? (
                        <div> {isNaN(parseFloat(props.item.fator_carga)) ? " - " : parseFloat(props.item.fator_carga).toFixed(2).replace(".", ",")}</div>
                    ) : props.item.id_modalidade_tarifaria == 2 ? (
                        <div>
                            <span>
                                {"FP: "} {isNaN(parseFloat(props.item.fator_carga_fora_ponta)) ? " - " : parseFloat(props.item.fator_carga_fora_ponta).toFixed(2).replace(".", ",")}
                            </span>
                            <span>
                                {"  |  P: "} {isNaN(parseFloat(props.item.fator_carga_ponta)) ? " - " : parseFloat(props.item.fator_carga_ponta).toFixed(2).replace(".", ",")}
                            </span>
                        </div>
                    ) : (
                        " - "
                    )}
                </div>
            </div>
            <div style={{ backgroundColor: "#ffa556", padding, borderRadius: 3 }}>
                <div style={{ minWidth: 85 }}>Fator de Demanda</div>
                <div>
                    {props.item.id_modalidade_tarifaria == 1 ? (
                        <div>{isNaN(parseFloat(props.item.fator_demanda_fora_ponta)) ? " - " : parseFloat(props.item.fator_demanda_fora_ponta).toFixed(2).replace(".", ",")}</div>
                    ) : props.item.id_modalidade_tarifaria == 2 ? (
                        <div>
                            <span>
                                {"FP: "}{" "}
                                {isNaN(parseFloat(props.item.fator_demanda_fora_ponta)) ? " - " : parseFloat(props.item.fator_demanda_fora_ponta).toFixed(2).replace(".", ",")}
                            </span>
                            <span>
                                {"  |  P: "} {isNaN(parseFloat(props.item.fator_demanda_ponta)) ? " - " : parseFloat(props.item.fator_demanda_ponta).toFixed(2).replace(".", ",")}
                            </span>
                        </div>
                    ) : (
                        " - "
                    )}
                </div>
            </div>
        </>
    );
}
